const ChairishContext = window.chairisher.context;

/**
 * @returns {Object} Mapping of experiment keys to Variant objects
 */
export default function getAmplitudeExperimentKeyToVariantMap() {
    return ChairishContext.AMPLITUDE_EXPERIMENT_KEY_TO_VARIANT_MAP;
}

/**
 * @return {boolean} An indication of whether the favorite action copy test is enabled
 * @todo (CHAIR-18433) - remove when beginning test
 */
export function isFavoriteActionCopyTestEnabled() {
    return !!ChairishContext.IS_FAVORITE_ACTION_COPY_TEST_ENABLED;
}
